import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SavedMessages = () => {
    const [savedMessages, setSavedMessages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [sourceEnvironment, setSourceEnvironment] = useState('any');
    const [error, setError] = useState('');

    const fetchSavedMessages = async (page = 1, search = '') => {
        try {
            const response = await axios.get('/api/messages', {
                params: {
                    page,
                    search,
                    environment: sourceEnvironment
                },
                withCredentials: true
            });
            if (response.data.status === 'success') {
                setSavedMessages(response.data.data.messages);
                setTotalPages(response.data.data.totalPages);
            }
        } catch (err) {
            setError('Failed to fetch saved messages');
        }
    };

    useEffect(() => {
        fetchSavedMessages();
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        setCurrentPage(1);
        fetchSavedMessages(1, searchQuery);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchSavedMessages(page, searchQuery);
    };

    const handleEnvironmentChange = (e) => {
        setSourceEnvironment(e.target.value);
        setCurrentPage(1);
        fetchSavedMessages(1, searchQuery);
    };

    return (
        <div className="saved-messages-container">
            <h2>Saved Messages</h2>
            <form onSubmit={handleSearch} className="search-form">
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search messages..."
                />
                <select
                    value={sourceEnvironment}
                    onChange={handleEnvironmentChange}
                >
                    <option value="any">Any</option>
                    <option value="dev">Dev</option>
                    <option value="prod">Prod</option>
                </select>
                <button type="submit">Search</button>
            </form>

            {error && <div className="error-message">{error}</div>}

            <div className="messages-list">
                {savedMessages.map(msg => (
                    <div key={msg.id} className="message-item">
                        <div className="field-row">
                            <span className="field-label">ID:</span>
                            <span className="field-content">{msg.id}</span>
                        </div>
                        <div className="field-row">
                            <span className="field-label">From:</span>
                            <span className="field-content">{msg.from}</span>
                        </div>
                        <div className="field-row">
                            <span className="field-label">Environment:</span>
                            <span className="field-content">{msg.environment}</span>
                        </div>
                        <div className="field-row">
                            <span className="field-label">User Description:</span>
                            <span className="field-content">{msg.userDescription}</span>
                        </div>
                        <div className="field-row">
                            <span className="field-label">Problem Class:</span>
                            <span className="field-content">{msg.problemClass.join(', ')}</span>
                        </div>
                        <div className="message-content">
                            <h5>Content:</h5>
                            <pre>{msg.text || msg.html}</pre>
                        </div>
                    </div>
                ))}
            </div>

            <div className="pagination">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <button
                        key={page}
                        onClick={() => handlePageChange(page)}
                        className={currentPage === page ? 'active' : ''}
                    >
                        {page}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SavedMessages; 